import { enviroment } from "../../../enviroment";
import { useClarityIdentity } from "../../../hooks/useClarityIdentity";

// Flag REACT_APP_CLARITY_ENABLED - build-time constant (SupplierStatusBanner
// pattern): with the flag off the export renders null and runs no hook, so
// the DOM is byte-identical. With it on, a null component that only runs
// useClarityIdentity() inside AuthenticatedView.
const clarityEnabled = enviroment.clarityEnabled;

function ClarityIdentityInner(): null {
  useClarityIdentity();
  return null;
}

export function ClarityIdentity(): JSX.Element | null {
  if (!clarityEnabled) return null;
  return <ClarityIdentityInner />;
}
